import { Typography, Breadcrumbs } from "@mui/material"
import { useEffect, useState } from "react"
import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import { useParams, Link, useNavigate, useLocation } from "react-router-dom"
import BreadcrumbModel from "shared/models/breadcrumb-model"

const BreadcrumbHeader = ({ content, open, onClose }) => {
  const params = useParams()
  const navigate = useNavigate()
  const routerLocation = useLocation()
  const [links, setLinks] = useState([])

  useEffect(() => {
    const pathNames = location.hash.split("/").filter(x => x && x != "#")
    const firstSegment = pathNames.length > 0 ? pathNames[0] : ""
    let result = []
    switch (firstSegment.toLowerCase()) {
      case "products":
        result = handleProductsBreadcrumb(pathNames)
        break

      case "inventory":
        result = handleInventoryBreadcrumb(pathNames)
        break

      case "sales-order":
        result = handleSalesOrderBreadcrumb(pathNames)
        break

      case "inbound-delivery":
        result = handleInboundBreadcrumb(pathNames)
        break

      case "return":
        result = handleReturnBreadcrumb(pathNames)
        break

      case "bom":
        result = handleBomBreadcrumb(pathNames)
        break
      case "dg-item-profile":
        result = handleDGItemProfileBreadcrumb(pathNames)
        break
    }

    setLinks(result)
  }, [])

  const handleProductsBreadcrumb = settings => {
    // If the user clicked through from /inventory, take them back there
    // instead of the Products search page.
    const cameFromInventory = routerLocation.state?.from === "/inventory"
    const parentLabel = cameFromInventory ? "Inventory" : "Products Search"
    const parentPath = cameFromInventory ? "/inventory" : "/products"

    if (settings.length >= 2) {
      if (settings.length > 2) {
        if (settings[2].toLowerCase() === "sales-order") {
          return [
            new BreadcrumbModel("Sales Order Search", true, "/sales-order"),
            new BreadcrumbModel(settings[3], true, `/sales-order/${params.erpOrder}/${params.id}`),
            new BreadcrumbModel(settings[1]),
          ]
        }

        if (settings[2].toLowerCase() === "inbound-delivery") {
          return [
            new BreadcrumbModel("Inbound Delivery Search", true, "/inbound-delivery"),
            new BreadcrumbModel(settings[3], true, `/inbound-delivery/${params.erpOrder}/${params.id}`),
            new BreadcrumbModel(settings[1]),
          ]
        }
      } else {
        return [new BreadcrumbModel(parentLabel, true, parentPath), new BreadcrumbModel(decodeURIComponent(settings[1]))]
      }
    }

    return [new BreadcrumbModel(parentLabel, true, parentPath)]
  }

  const handleInventoryBreadcrumb = () => {
    return [new BreadcrumbModel("Inventory", false)]
  }

  const handleSalesOrderBreadcrumb = settings => {
    if (settings.length && settings.length > 2) {
      return [new BreadcrumbModel("Sales Order Search", true, "/sales-order"), new BreadcrumbModel(decodeURIComponent(settings[1]), false)]
    }

    return [new BreadcrumbModel("Sales Order Search", false)]
  }

  const handleInboundBreadcrumb = settings => {
    if (settings.length && settings.length > 2) {
      return [new BreadcrumbModel("Inbound Delivery Search", true, "/inbound-delivery"), new BreadcrumbModel(decodeURIComponent(settings[1]), false)]
    }

    return [new BreadcrumbModel("Inbound Delivery Search", false)]
  }

  const handleReturnBreadcrumb = settings => {
    if (settings.length) {
      return [new BreadcrumbModel("Return Search", false)]
    }

    return []
  }

  const handleBomBreadcrumb = settings => {
    if (settings.length && settings.length >= 2) {
      return [new BreadcrumbModel("Bill of Materials Search", true, "/bom"), new BreadcrumbModel(decodeURIComponent(settings[1]), false)]
    }

    return [new BreadcrumbModel("Bill of Materials Search", false)]
  }

  const handleDGItemProfileBreadcrumb = settings => {
    if (settings.length && settings.length >= 2) {
      return [new BreadcrumbModel("DG Item Profile Search", true, "/dg-item-profile"), new BreadcrumbModel(decodeURIComponent(settings[2]), false)]
    }

    return [new BreadcrumbModel("DG Item Profile Search", false)]
  }

  const handleClick = (event, url) => {
    event.preventDefault()
    navigate(url, { replace: true })
  }

  return (
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" style={{ padding: 16 }}>
      {links.map(x => {
        return x.IsLink ? (
          <Link underline="hover" key={x.Name} color="inherit" onClick={event => handleClick(event, x.LinkTo)}>
            {x.Name}
          </Link>
        ) : (
          <Typography key={x.Name} color="text.primary">
            {x.Name}
          </Typography>
        )
      })}
    </Breadcrumbs>
  )
}

export default BreadcrumbHeader
